export default function WhySection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-16 lg:gap-20">
          <div className="lg:w-1/2 lg:pr-8">
            <p className="text-xs font-semibold text-foreground-500 uppercase tracking-[0.2em] mb-4 font-label">
              Why OOPBuy Spreadsheets
            </p>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 font-heading leading-[1.12]">
              Smarter Data
              <br />
              For Faster
              <br />
              Sourcing Decisions
            </h2>

            <p className="mt-8 text-base md:text-lg text-foreground-600 leading-relaxed max-w-[480px]">
              OOPBuy spreadsheets help you track product data efficiently, compare suppliers and listings, analyze pricing trends, and accelerate your sourcing speed. Whether you are a beginner in dropshipping, an e-commerce seller, or a product researcher, structured spreadsheet systems give you the competitive edge you need.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-5">
              {[
                { icon: "ri-flashlight-line", title: "Faster Research", desc: "Speed up product discovery with structured data" },
                { icon: "ri-line-chart-line", title: "Better Analysis", desc: "Compare pricing trends and supplier metrics" },
                { icon: "ri-brain-line", title: "Smarter Decisions", desc: "Data-driven insights for your business" },
                { icon: "ri-database-2-line", title: "Centralized Data", desc: "All your sourcing data in one place" },
              ].map((item, i) => (
                <div key={i} className="flex gap-3">
                  <span className="w-10 h-10 flex items-center justify-center shrink-0 rounded-xl bg-background-50 text-foreground-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-950 font-heading">{item.title}</h4>
                    <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col gap-6">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20home%20office%20with%20macbook%20on%20minimalist%20oak%20desk%20displaying%20colorful%20analytics%20charts%2C%20green%20plant%20nearby%2C%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20cozy%20productive%20vibe%2C%20clean%20Scandinavian%20interior%2C%20soft%20warm%20natural%20light%2C%20editorial%20workspace%20photography&width=800&height=500&seq=why-v2-01&orientation=landscape"
              alt="OOPBuy Spreadsheet workspace setup"
              className="w-full rounded-[24px] object-cover"
              loading="lazy"
            />
            <img
              src="https://readdy.ai/api/search-image?query=Aesthetic%20product%20display%20of%20designer%20caps%20jewelry%20and%20small%20accessories%20on%20a%20rustic%20wooden%20table%2C%20dappled%20sunlight%20through%20leaves%2C%20outdoor%20market%20feel%2C%20warm%20golden%20hour%20glow%2C%20bohemian%20artisan%20style%2C%20rich%20textures%2C%20editorial%20lifestyle%20photography%2C%20inviting%20atmosphere&width=800&height=400&seq=why-v2-02&orientation=landscape"
              alt="OOPBuy product sourcing showcase"
              className="w-full rounded-[24px] object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}